module.exports = __webpack_public_path__ + "images/frontpage_hotkeys@3x.png?3b73165b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_hotkeys@3x.png
// module id = 647
// module chunks = 7